import React from "react";
import { Reveal, Label } from "./anim";
import { EDUCATION } from "../data/content";
import { GraduationCap } from "lucide-react";

export const Credentials = () => {
  return (
    <section data-testid="credentials-section" className="relative bg-[#EFEBDE] py-24 md:py-40 border-t border-[#16281C]/10">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12">
        <Reveal>
          <Label>Education</Label>
          <div className="mt-8 grid md:grid-cols-2 lg:grid-cols-3 gap-4">
            {EDUCATION.map((ed) => (
              <div
                key={ed.degree + ed.school}
                className="group flex gap-5 bg-[#FAF8F1] border border-[#16281C]/12 p-7 md:p-8 hover:border-[#2C5F3A]/40 transition-colors"
              >
                <GraduationCap size={24} className="text-[#2C5F3A] shrink-0 mt-1" strokeWidth={1.5} />
                <div>
                  <h4 className="font-display font-semibold text-xl md:text-2xl tracking-tight text-[#16281C] leading-snug">
                    {ed.degree}
                  </h4>
                  <p className="mt-2 font-body text-sm md:text-base text-[#66766A]">
                    {ed.school}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
};
